export var Size;
(function (Size) {
    Size["None"] = "none";
    Size["Small"] = "sm";
    Size["Medium"] = "md";
})(Size || (Size = {}));
export var Padding;
(function (Padding) {
    Padding["None"] = "padding-none";
})(Padding || (Padding = {}));
export var Spacing;
(function (Spacing) {
    Spacing["None"] = "spacing-none";
    Spacing["Small"] = "spacing-sm";
    Spacing["Medium"] = "spacing-md";
    Spacing["Large"] = "spacing-lg";
    Spacing["ExtraLarge"] = "spacing-xl";
    Spacing["DoubleExtraLarge"] = "spacing-2xl";
})(Spacing || (Spacing = {}));
